import $ from 'jquery';
import prestashop from "prestashop";
import { createComponent } from '@front/utils/alpine';

function toggleBodyOverflow (force: boolean) {
    document.body.classList.toggle('overflow-y-hidden', force);
    document.body.classList.toggle('h-[100vh]', force);
    document.querySelector('#main')?.classList.toggle('relative', force);
    document.querySelector('#main')?.classList.toggle('z-[50]', force);
}

const modal = createComponent(() => ({
    isOpened: false,

    toggle (force: boolean) {
        this.isOpened = force == undefined ? !this.isOpened : force;
    },

    setup () {
        const element = this.$el;
        const link = element?.querySelector('a');
        const modalTitle = element?.querySelector('.js-modal-title') as HTMLElement;
        const modalContent = element?.querySelector('.js-modal-content') as HTMLElement;
        let url = link?.href;

        toggleBodyOverflow(this.isOpened);
        this.$watch('isOpened', toggleBodyOverflow);

        link?.addEventListener('click', (e) => {
            e.preventDefault();

            this.toggle(true);

            if (url) {
                url += '?content_only=1';
                $.get(url, (content) => {
                    modalTitle.innerHTML = $(content).find('h1').html();
                    modalContent.innerHTML = $(content).find('.page-cms').html();
                }).fail((resp) => {
                    prestashop.emit('handleError', {eventType: 'clickTerms', resp});
                });
            }
        })
    },
}));

export default {
    modal,
};